export const getCardBorderRadius = (shape: string | undefined) => {
  switch (shape) {
    case 'rounded':
      return '52px';
    case 'circle':
      return '50%';
    default:
      return '0';
  }
};

export const getCardBleedBorderRadius = (shape: string | undefined) => {
  switch (shape) {
    case 'rounded':
      return '26px';
    case 'circle':
      return '50%';
    default:
      return '0';
  }
};
